module.exports = __webpack_public_path__ + "img/sector27.e6610e53.svg";